<template>
  <div>
    <h4>Whats New in Credible</h4>
    <hr>
  </div>
</template>

<script>
	export default {

	}
</script>
